import { useIntl } from 'react-intl';
import AccionaBigButton from '../../../components/AccionaBigButton';
import { useNavigate, useOutletContext } from 'react-router-dom';

const Home = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { project } = useOutletContext();
  return (
    <>
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <AccionaBigButton
            icon="ocr"
            msg={intl.formatMessage({ id: 'routes.ocr' })}
            onClick={() => navigate('ocr')}
          />
        </div>
        <div className="col-sm-12 col-md-6">
          <AccionaBigButton
            icon="ehe"
            msg={intl.formatMessage({
              id: `routes.${project?.id_normative === 1 ? 'ehe' : 'coe'}`,
            })}
            onClick={() => {
              navigate(
                `/app/project/${project.id_project}/quality/normative/${
                  project?.id_normative === 1 ? 'ehe' : 'coe'
                }`,
              );
            }}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12">
          <AccionaBigButton
            icon="dashboard"
            msg={intl.formatMessage({ id: 'routes.dashboard' })}
            onClick={() => navigate('dashboard')}
          />
        </div>
      </div>
    </>
  );
};

export default Home;
